import React, {useState, useEffect, Component} from 'react';
import {View, Text, BackHandler} from 'react-native';
import Requests from '../api/Requests';
import {TableContainer} from '../components/table/Table';
import styled, {css} from 'styled-components/native';
import {colours, fontSize, spacing} from '../styles/Style';
import {
  GetGlobalTheme,
  IsHRWeb,
  DataTypes,
  WindowTypes,
  GetParameterID,
  GetDefaultBackBehaviour,
  WindowWrap,
  DisplayBrowseOKFlag,
  IsHRiOS,
  goBack,
  DoNavigate,
  ScreenHeight,
  ScreenWidth,
  UsePagination,
  Supported,
  ResetRecord,
} from '../Tools/DisplayTools';
import {ActionButton} from '../components/button/ActionButton';
import {YesNoWindow} from '../components/status/YesNoWindow';
import {InspectWindow} from '../components/edit_elements/InspectWindow';
import {b64toBlob} from '../Tools/Base64Decode';
import {translate} from '../Tools/LanguageTools';
import {Modal} from 'react-native';
import {GetDayColor} from '../components/edit_elements/Shifts';
import EditField from '../components/edit_elements/EditField';
import {ModalWindow} from '../components/status/ModalWindow';
import {SetCurrentWindow2, AddDateFilter} from '../Tools/WindowTools';
import {LangColorContext} from '../App';
import {createDrawerNavigator} from '@react-navigation/drawer';

const kDefPerPage = 20;
const Drawer = createDrawerNavigator();

const headerfields = (table) => [
  {
    group: {
      fields: [
        {
          title: translate('SerNr'),
          dataKey: 'SerNr',
          viewOnly: true,
          width: '100px',
        },
        {
          title: translate('Department'),
          dataKey: 'DepCode',
          viewOnly: true,
          width: '150px',
        },
        {
          title: translate('Date'),
          dataKey: 'RegDate',
          viewOnly: false,
          width: '150px',
          type: DataTypes.kInputTypeDate,
          onChange: table.handleInputChange,
        },
        {
          title: translate('StartDate'),
          dataKey: 'StartDate',
          viewOnly: true,
          width: '150px',
          type: DataTypes.kInputTypeDate,
        },
        {
          title: translate('EndDate'),
          dataKey: 'EndDate',
          viewOnly: true,
          width: '150px',
          type: DataTypes.kInputTypeDate,
        },
        {
          title: translate('Approved'),
          title2: translate('Approve'),
          dataKey: 'OKFlag',
          viewOnly: false,
          type: DataTypes.kInputTypeCheckbox,
          onChange: table.handleInputChange,
        },
      ],
    },
  },
];

const matrixfooterfields = (table) => [
  {
    group: {
      fields: [
        {
          title: translate('OpenShiftSheet'),
          action: table.openShiftSheet,
          width: '150px',
          type: DataTypes.kInputTypeButton,
        },
        {
          title: translate('Total'),
          dataKey: 'TimeSum',
          viewOnly: true,
          width: '150px',
          row: true,
          style: {
            backgroundColor: colours[GetGlobalTheme()].inputBackground,
            textAlign: 'right',
            paddingRight: spacing.medium,
          },
        },
      ],
      styles: {
        justifyContent: 'flex-end',
      },
    },
  },
];

const TimeTableColumns = (table, widef = false) => {
  let res = [];
  res.push({
    title: translate('ContractNr'),
    dataKey: 'ContractNr',
    width: '90px',
    viewOnly: true,
  });
  res.push({
    title: translate('Employee'),
    dataKey: 'EmpName',
    width: widef ? '140px' : '120px',
    viewOnly: true,
    showProfile: 'EmpCode',
  });
  res.push({
    title: translate('Type'),
    dataKey: 'TrName',
    width: widef ? '140px' : '100px',
    viewOnly: true,
  });

  let vColor = GetDayColor(table.state.record);
  for (let i = 1; i < 32; i++) {
    res.push({
      title: i,
      dataKey: 'Day' + i,
      width: widef ? '25px' : '20px',
      viewOnly: false,
      type: DataTypes.kInputTypeVal,
      overwrite: table.overwriteMatrixRow,
      style: {
        justifyContent: 'center',
        textAlign: 'center',
        height: '23px',
        fontSize: '12px',
      },
      cellstyle: {backgroundColor: vColor[i], justifyContent: 'center'},
      onchange: table.handleInputChange,
    });
  }
  res.push({
    title: translate('QtyShort'),
    dataKey: 'Qty',
    type: DataTypes.kInputTypeVal,
    width: '45px',
    viewOnly: true,
    style: {justifyContent: 'flex-end', textAlign: 'right'},
  });
  res.push({
    title: translate('Total'),
    dataKey: 'DQty',
    type: DataTypes.kInputTypeVal,
    width: '38px',
    viewOnly: true,
    overwrite: table.overwriteMatrixRowDQty,
    style: {justifyContent: 'flex-end', textAlign: 'right'},
  });
  res.push({
    title: translate('Days'),
    dataKey: 'DayCnt',
    width: '38px',
    viewOnly: true,
    style: {justifyContent: 'flex-end', textAlign: 'right'},
    cellstyle: {borderLeft: '1px solid #ddd', marginLeft: 5},
  });
  return res;
};

function TimeTableRowActions(table) {
  if (global.userData.deplist != '') {
    let res = [];
    if (table.state.record.OKFlag != '1') {
      res.push({
        name: translate('InsertRow'),
        action: table.copyMatrixRow,
      });
      res.push({
        name: translate('DeleteRow'),
        action: table.deleteMatrixRow,
      });
    }
    /*
    res.push({
      name: translate('InsertRow'),
      action: table.insertMatrixRow,
    });
    */
    if (res.length > 0) {
      return res;
    }
  }
}

let FilterView;
if (IsHRWeb()) {
  FilterView = styled.View`
    position: absolute;
    top: 100%;
    right: 0px;
    width: 240px;
    background: ${colours[GetGlobalTheme()].lightBackground};
    padding: 20px;
    flex-direction: column;
    align-items: center;
  `;
} else {
  if (IsHRiOS()) {
    FilterView = styled.View`
      position: absolute;
      height: ${ScreenHeight()};
      width: ${ScreenWidth()};
      background: ${colours[GetGlobalTheme()].lightBackground};
      padding: 6px;
    `;
  } else {
    FilterView = styled.Modal``;
  }
}

const FilterViewInner = styled.View`
  ${IsHRWeb() == false &&
  css`
    height: 100%;
    width: 100%;
    background-color: ${colours[GetGlobalTheme()].siteBackground};
  `};
  ${IsHRiOS() &&
  css`
    padding-top: 50;
  `};
`;

const FilterFields = styled.View`
  ${IsHRWeb() &&
  css`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    margin-right: -30px;
  `}
`;
const FilterActions = styled.View`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
`;

const FilterField = styled.View`
  margin-right: 30px;
`;
const FilterLabel = styled.View`
  margin-bottom: 2px;
`;
const FilterLabelText = styled.Text`
  color: ${colours[GetGlobalTheme()].normalHighligh};
  font-size: ${fontSize.small200};
`;

const FilterSelect = styled.View`
  height: 35px;
`;

const MatrixDivider = styled.View`
  ${(IsHRWeb() &&
    css`
      width: calc(100% - ${spacing.medium * 2}px - 12px);
    `) ||
  css`
    width: 100%;
  `}
  height: 1px;
  border-bottom-color: ${colours[GetGlobalTheme()].normalHighligh};
  border-bottom-width: 1;
  margin-horizontal: ${spacing.medium250};
  border-radius: 6px;
`;

function CurrentDate() {
  return new Date();
}

class TimeTablesList extends Component {
  constructor(props) {
    super(props);
    let self = this;
    this.createNewTable = this.createNewTable.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.renderNewButton = this.renderNewButton.bind(this);

    //this.changePage = this.changePage.bind(this);
    this._isMounted = true;
    this.LocalOffWork = null;
    this.ScreenName = 'TimeTables';
    this.init = true;
    this.state = {
      data: [],
      record: {},
      show: false,
      WindowType: WindowTypes.Browse,
      newTableHelper: false,
      Month: '01',
      Year: CurrentDate().getFullYear(),
      Department: global.userData.deplist.split(',').pop(),
      px: 0,
      py: 0,
      NewRowContract: '',
      NewRowType: '',
      NewRowIndex: -1,
      newMatrixTableHelper: false,
      update: false,
    };
    this.navigation = props.navigation;
    SetCurrentWindow2('TimeTables', 'SerNr', 'descending');
    AddDateFilter('TimeTables');
    this.setState({update: true});
    //this.displayBrowseList();
  }
  getBrowseListData = () => {
    let self = this;
    Requests.getTableData(5, undefined, undefined, undefined, true)
      .then((response) => {
        if (self._isMounted) {
          self.setState({data: response.records});
        }
      })
      .catch((error) => {});
  };
  displayBrowseList = () => {
    this.state.WindowType = WindowTypes.Browse;
    this.state.newTableHelper = false;
    this.getBrowseListData();
  };
  setMatrixPagination = (cnt) => {
    this.state.pagination.page = 0;
    this.state.pagination.pages =
      parseInt(cnt / this.state.pagination.perpage) + 1;
  };
  rowClick = (id) => {
    DoNavigate(this, 'TimeTables', true, id);
  };
  CheckNewTableData = () => {
    let res = true;
    if (this.state.Year == '') {
      res = false;
    }
    if (this.state.Month == '') {
      res = false;
    }
    return res;
  };

  createNewTable = () => {
    let self = this;
    if (this.CheckNewTableData() == false) {
      global.messageBox({
        showMessage: true,
        statusMessage: translate('FillMandFields'),
      });
      return;
    }
    let tdata = {
      record: {
        StartDate: this.state.Year + '-' + this.state.Month + '-01',
        DepCode: this.state.Department,
        APIFlag: 1,
      },
    };
    this.LocalOffWork = null;
    Requests.getNewRecord(5, tdata)
      .then((response) => {
        if (response.success == true) {
          self.ShowHideNewTable();
          if (UsePagination() == false) {
            self.getBrowseListData();
          }
          self.rowClick(response.record.SerNr);
        }
      })
      .catch((error) => {});
  };
  componentDidMount() {
    let self = this;
    this.focusSubscription = this.props.navigation.addListener('focus', () => {
      SetCurrentWindow2('TimeTables', '', '');
      if (UsePagination() == false) {
        self.getBrowseListData();
      } else {
        if (self.init == false) {
          self.setState({update: self.state.update ? false : true});
        }
        self.init = false;
      }
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  ShowHideNewTable = () => {
    if (this.state.newTableHelper) {
      global.PopEscapeActions();
      this.setState({newTableHelper: false});
    } else {
      this.setState({newTableHelper: true});
      global.PushEscapeActions(() => this.ShowHideNewTable());
    }
  };

  renderNewButton = () => {
    let self = this;
    let style2 = {};
    if (IsHRiOS()) {
      style2 = {
        left: -this.state.px,
        top: -this.state.py,
      };
    }
    return (
      <View
        key={'timetables_new'}
        onLayout={(event) => {
          const layout = event.nativeEvent.layout;
          self.setState({py: layout.y, px: layout.x});
        }}
      >
        {Supported('nonewtimetables') == false && (
          <>
            <ActionButton
              onPress={() => this.ShowHideNewTable()}
              title={translate('AddNew')}
            />
            {this.state.newTableHelper && (
              <FilterView style={style2}>
                <FilterViewInner>
                  <FilterFields>
                    <FilterField>
                      <EditField
                        title={translate('Department')}
                        value={this.state.Department}
                        width={'180px'}
                        ps={7}
                        psfields={['depcode', 'name']}
                        psheader={[
                          {
                            name: translate('Code'),
                            width: '35%',
                            key: 'DepCode',
                            mainkey: 'DepCode',
                          },
                          {
                            width: '65%',
                            name: translate('Name'),
                            key: 'Name',
                          },
                        ]}
                        onChange={(index, fn, value) => {
                          self.setState({Department: value});
                        }}
                      />
                    </FilterField>
                    <FilterField>
                      <EditField
                        title={translate('Year') + '*'}
                        value={this.state.Year}
                        width={'180px'}
                        ps={9993}
                        psfields={['code', 'comment']}
                        onChange={(index, fn, value) =>
                          self.setState({Year: value})
                        }
                      />
                    </FilterField>
                    <FilterField>
                      <EditField
                        title={translate('Month') + '*'}
                        value={this.state.Month}
                        width={'180px'}
                        ps={9994}
                        psfields={['code', 'comment']}
                        onChange={(index, fn, value) =>
                          self.setState({Month: value})
                        }
                      />
                    </FilterField>
                  </FilterFields>
                  <FilterActions>
                    <ActionButton
                      style={{marginTop: '20px', marginRight: '20px'}}
                      onPress={() => this.ShowHideNewTable()}
                      title={translate('Cancel')}
                    />
                    <ActionButton
                      style={{marginTop: '20px'}}
                      onPress={() => this.createNewTable()}
                      title={translate('Create')}
                    />
                  </FilterActions>
                </FilterViewInner>
              </FilterView>
            )}
          </>
        )}
      </View>
    );
  };
  render() {
    let self = this;
    return (
      <LangColorContext.Consumer>
        {(data) => {
          return (
            <WindowWrap>
              <TableContainer
                data={this.state.data}
                table={5}
                update={this.state.update}
                columns={[
                  {
                    title: translate('SerNr'),
                    dataKey: 'sernr',
                    sortKey: 'SerNr',
                    width: '150px',
                  },
                  {
                    title: translate('Department'),
                    dataKey: 'depcode',
                    sortKey: 'DepCode',
                    width: '150px',
                  },
                  {
                    title: translate('Date'),
                    dataKey: 'regdate',
                    sortKey: 'RegDate',
                    width: '170px',
                    type: DataTypes.kInputTypeDate,
                  },
                  {
                    title: translate('StartDate'),
                    dataKey: 'startdate',
                    sortKey: 'StartDate',
                    width: '170px',
                    type: DataTypes.kInputTypeDate,
                  },
                  {
                    title: translate('EndDate'),
                    dataKey: 'enddate',
                    sortKey: 'EndDate',
                    width: '170px',
                    type: DataTypes.kInputTypeDate,
                  },
                  {
                    title: translate('Approved'),
                    dataKey: 'okflag',
                    sortKey: 'OKFlag',
                    width: '100px',
                    overwrite: DisplayBrowseOKFlag,
                  },
                ]}
                doClick={self.rowClick}
                rowID={'sernr'}
                title={translate(this.ScreenName)}
                width="800px"
                extraContent={this.renderNewButton}
              />
            </WindowWrap>
          );
        }}
      </LangColorContext.Consumer>
    );
  }
}

class TimeTablesRecord extends Component {
  constructor(props) {
    super(props);
    let self = this;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputChangeEvent = this.handleInputChangeEvent.bind(this);
    this.copyMatrixRow = this.copyMatrixRow.bind(this);
    this.deleteMatrixRow = this.deleteMatrixRow.bind(this);
    this.insertMatrixRow = this.insertMatrixRow.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.openShiftSheet = this.openShiftSheet.bind(this);
    this.overwriteMatrixRow = this.overwriteMatrixRow.bind(this);
    this.overwriteMatrixRowDQty = this.overwriteMatrixRowDQty.bind(this);
    this.shouldShowMatrixRow = this.shouldShowMatrixRow.bind(this);

    //this.changePage = this.changePage.bind(this);
    this._isMounted = true;
    this.LocalOffWork = null;
    this.ScreenName = 'TimeTables';
    this.state = {
      data: [],
      record: {},
      show: false,
      WindowType: WindowTypes.Browse,
      newTableHelper: false,
      Month: '01',
      Year: CurrentDate().getFullYear(),
      Department: global.userData.deplist.split(',').pop(),
      NewRowContract: '',
      NewRowType: '',
      NewRowIndex: -1,
      showrightbar: false,
      newMatrixTableHelper: false,
      pagination: {
        page: 0,
        perpage: kDefPerPage,
        pages: 0,
        change: function (page) {
          self.changePage(page);
        },
        changePagePeriod: function (value) {
          self.changePagePeriod(value);
        },
      },
    };
    this.navigation = props.navigation;
    if (props.route.params?.id) {
      this.state.ActiveID = props.route.params.id;
      this.rowClick(props.route.params.id);
    }
  }
  setMatrixPagination = (cnt) => {
    this.state.pagination.page = 0;
    this.state.pagination.pages =
      parseInt(cnt / this.state.pagination.perpage) + 1;
  };
  rowClick = (id) => {
    let self = this;
    this.state.WindowType = WindowTypes.Inspect;
    this.LocalOffWork = null;
    this.setState({record: {}});
    Requests.getTableData(5, {SerNr: id}, undefined, undefined, true)
      .then((response) => {
        self.state.id = response.records[0].SerNr;
        self.setMatrixPagination(response.records[0].rows.length);
        self.setState({record: response.records[0]}, () => {
          self.UpdateWithOffWorkData();
        });
      })
      .catch((error) => {});
  };
  openShiftSheet = () => {
    if (
      this.state.record.ShiftSerNr != '-1' &&
      this.state.record.ShiftSerNr != ''
    ) {
      DoNavigate(this, 'ShiftTables', true, this.state.record.ShiftSerNr);
    } else {
      alert(translate('NoShiftSheet'));
    }
  };
  insertMatrixRow = (index) => {
    this.state.NewRowContract = '';
    this.state.NewRowType = '';
    this.state.NewRowIndex = index;
    this.setState({newMatrixTableHelper: true});
  };
  copyMatrixRow = (index) => {
    this.state.NewRowContract = this.state.record.rows[index].ContractNr;
    this.state.NewRowType = '';
    this.state.NewRowIndex = index;
    this.setState({newMatrixTableHelper: true});
  };
  deleteMatrixRow = (index) => {
    let self = this;
    let sernr = this.state.record.SerNr;
    Requests.deleteRecordRow(5, sernr + ':' + index)
      .then((response) => {
        if (response.success) {
          Requests.getTableData(5, {SerNr: sernr})
            .then((response) => {
              response.records[0].id = response.records[0].SerNr;
              self.setMatrixPagination(response.records[0].rows.length);
              self.setState({record: response.records[0]}, () => {
                self.UpdateWithOffWorkData2();
              });
            })
            .catch((error) => {});
        }
      })
      .catch((error) => {});
  };
  GetTimeTrCode = (tval) => {
    let res;

    for (let i in global.pasteSpecials[22]) {
      if (tval == global.pasteSpecials[22][i].code) {
        res = global.pasteSpecials[22][i].timetr;
        break;
      }
    }

    return res;
  };
  createNewTableRow = () => {
    let self = this;
    Requests.insertRecordRow(
      5,
      this.state.record.SerNr + ':' + (this.state.NewRowIndex + 1) + ':1'
    )
      .then((response) => {
        if (response.success) {
          if (self._isMounted) {
            let res = {
              list: [
                {
                  rownr: self.state.NewRowIndex + 1,
                  field: 'ContractNr',
                  value: self.state.NewRowContract,
                },
                {
                  rownr: self.state.NewRowIndex + 1,
                  field: 'TrType',
                  value: self.state.NewRowType,
                },
                {
                  rownr: self.state.NewRowIndex + 1,
                  field: 'TimeTrType',
                  value: self.GetTimeTrCode(self.state.NewRowType),
                },
                {
                  rownr: self.state.NewRowIndex + 1,
                  field: 'stp',
                  value: 2,
                },
              ],
              id: self.state.record.SerNr,
            };
            Requests.updateRecordData(5, res)
              .then((response) => {
                if (response.success) {
                  if (self._isMounted) {
                    self.state.record = {};
                    self.setState({record: response.record}, () => {
                      self.UpdateWithOffWorkData2();
                    });
                    self.setState({newMatrixTableHelper: false});
                  }
                }
              })
              .catch((error) => {});
          }
        }
      })
      .catch((error) => {});
  };

  handleInputChange = (rowindex, index, value) => {
    let self = this;
    Requests.updateRecordData(5, {
      field: index,
      rownr: rowindex,
      value: value,
      id: this.state.record.SerNr,
    })
      .then((response) => {
        if (response.success) {
          if (self._isMounted) {
            self.state.record = {};
            self.setState({record: response.record}, () => {
              self.UpdateWithOffWorkData2();
            });
          }
        } else {
          if (self._isMounted) {
            ResetRecord(self, index, rowindex, value);
          }
        }
      })
      .catch((error) => {});
  };
  handleInputChangeEvent = (rowindex, index, event) => {
    this.handleInputChange(rowindex, index, event.target.value);
  };
  overwriteMatrixRow = (value, rowindex, index, value2 = '', datakey) => {
    let res = false;
    if (this.LocalOffWork && this.LocalOffWork[rowindex]) {
      if (this.LocalOffWork[rowindex][datakey] != '') {
        res = [];
        res.push(
          <View style={{textAlign: 'center'}}>
            <Text>{this.LocalOffWork[rowindex][datakey]}</Text>
          </View>
        );
      }
    }
    return res;
  };
  overwriteMatrixRowDQty = (value, rowindex, index, value2 = '', datakey) => {
    let res = false;

    if (this.state.record.rows[rowindex]['stp'] != '1') {
      res = [];
      res.push(<View></View>);
    }
    return res;
  };
  GetContractList = () => {
    let res = [];
    for (let i = 0; i < this.state.record.rows.length; i++) {
      res.push(this.state.record.rows[i].ContractNr);
    }
    return res.join(',');
  };

  UpdateWithOffWorkData2 = () => {
    let update = this.LocalOffWork;
    let rec = this.state.record;
    for (let i = 0; i < update.length; i++) {
      for (let j = 0; j < rec.rows.length; j++) {
        if (rec.rows[j].ContractNr == update[i].ContractNr) {
          for (let s = 1; s < 32; s++) {
            if (update[i]['Day' + s] != '') {
              rec.rows[j]['Day' + s] = update[i]['Day' + s];
            }
          }
          break;
        }
      }
    }
    this.setState({record: rec});
  };

  UpdateWithOffWorkData = () => {
    let self = this;
    let update = [];
    Requests.doAction('getoffwork', {
      id:
        'empty&sd=' +
        this.state.record.StartDate +
        '&ed=' +
        this.state.record.EndDate +
        '&contractlist=' +
        self.GetContractList(),
    })
      .then((response) => {
        let rec = self.state.record;
        for (let i = 0; i < response.record.rows.length; i++) {
          for (let j = 0; j < rec.rows.length; j++) {
            if (rec.rows[j].ContractNr == response.record.rows[i].ContractNr) {
              update[i] = {ContractNr: rec.rows[j].ContractNr};
              for (let s = 1; s < 32; s++) {
                update[i]['Day' + s] = '';
                if (response.record.rows[i]['Day' + s] != '') {
                  rec.rows[j]['Day' + s] = response.record.rows[i]['Day' + s];
                  update[i]['Day' + s] = response.record.rows[i]['Day' + s];
                }
              }
              break;
            }
          }
        }
        self.LocalOffWork = update;
        self.setState({record: rec});
      })
      .catch((error) => {});
  };

  shouldShowMatrixRow = (row) => {
    let res = true;

    return res;
  };
  componentDidUpdate(props) {
    let param_id = GetParameterID(this);
    if (this.state.ActiveID != param_id && param_id != '') {
      this.state.ActiveID = param_id;
      this.rowClick(this.state.ActiveID);
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  changePage = (page) => {
    let npagination = this.state.pagination;
    npagination.page = page;
    this.setState({pagination: npagination});
  };
  changePagePeriod = (value) => {
    let npagination = this.state.pagination;
    npagination.perpage = value;
    npagination.page = 0;
    this.setMatrixPagination(this.state.record.rows.length);
    this.setState({pagination: npagination});
  };
  SplitMatrixRow = (curRow, prevRow) => {
    let res = [];
    if (prevRow !== undefined && curRow.ContractNr !== prevRow.ContractNr) {
      res.push(
        <MatrixDivider
          key={'divider' + curRow.ContractNr + prevRow.ContractNr}
        />
      );
    }
    return res;
  };
  deleteRecord = () => {
    let self = this;
    this.setState({activeDelete: false});
    Requests.deleteRecord(5, this.state.record.SerNr)
      .then((response) => {
        if (response.success === true) {
          self.state.ActiveID = '';
          DoNavigate(self, 'TimeTables', false, '', true, true);
        }
      })
      .catch((error) => {});
  };

  downloadDocument = () => {
    /*application/octet-stream*/
    let self = this;
    //window.open('about:blank', 'Downloading');
    Requests.downloadDocument(5, {id: this.state.record.SerNr})
      .then((response) => {
        if (response.file !== '') {
          let blob = b64toBlob(response.file, 'application/pdf');
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          // the filename you want
          //a.download = response.name;
          //  a.target = '_blank';
          document.body.appendChild(a);
          window.open(url, 'Downloading');
          //window.URL.revokeObjectURL(url);
        } else {
          global.messageBox({
            showMessage: true,
            statusMessage: translate('DocumentNotFound'),
          });
        }
      })
      .catch((error) => {});
  };

  renderNewRowButton = () => {
    let self = this;
    return (
      <View>
        <FilterFields>
          <FilterField>
            <EditField
              title={translate('Contract')}
              name={'Contract'}
              value={this.state.NewRowContract}
              ps={1}
              style={{width: 215}}
              psfilter={{depcode: this.state.record.DepCode}}
              psheader={[
                {
                  name: translate('Code'),
                  width: '35%',
                  key: 'contractnr',
                  mainkey: 'ContractNr',
                },
                {
                  width: '65%',
                  name: translate('Name'),
                  key: 'empname',
                },
              ]}
              onChange={(index, fn, value) =>
                self.setState({NewRowContract: value})
              }
            />
          </FilterField>
          <FilterField>
            <EditField
              title={translate('Type')}
              name={'Type'}
              value={this.state.NewRowType}
              ps={22}
              style={{width: 215}}
              psheader={[
                {
                  name: translate('Code'),
                  width: '35%',
                  key: 'Code',
                  mainkey: 'Code',
                },
                {
                  width: '65%',
                  name: translate('Comment'),
                  key: 'Name',
                },
              ]}
              onChange={(index, fn, value) =>
                self.setState({NewRowType: value})
              }
            />
          </FilterField>
        </FilterFields>
        <FilterActions>
          <ActionButton
            style={{marginTop: '20px', marginRight: '20px'}}
            onPress={() => this.setState({newMatrixTableHelper: false})}
            title={translate('Cancel')}
          />
          <ActionButton
            style={{marginTop: '20px'}}
            onPress={() => this.createNewTableRow()}
            title={translate('Add')}
          />
        </FilterActions>
      </View>
    );
  };
  IsWideScreen = (data) => {
    let res = false;
    if (global.isDrawerOpen) {
      res = true;
    }
    return res;
  };

  render() {
    let self = this;
    let width = 1080;
    return (
      <LangColorContext.Consumer>
        {(data) => {
          return (
            <WindowWrap>
              {this.state.WindowType === WindowTypes.Inspect && (
                <InspectWindow
                  title={translate('TimeTable')}
                  window={this}
                  headerfields={headerfields(this)}
                  matrixFooterFields={matrixfooterfields(this)}
                  record={this.state.record}
                  columns={TimeTableColumns(this, this.IsWideScreen(data))}
                  rowactions={TimeTableRowActions(this)}
                  showrow={this.shouldShowMatrixRow}
                  onClick={this.handleInputClick}
                  pagination={this.state.pagination}
                  splitrow={(row1, row2) => self.SplitMatrixRow(row1, row2)}
                  okcheck={'OKFlag'}
                  allowDelete={true}
                  allowPrint={IsHRWeb()}
                  // width="1293px"
                  //width="1309px"
                  width={this.IsWideScreen(data) ? '1300px' : '1080px'}
                  minwidth={this.IsWideScreen(data) ? '1100px' : '1050px'}
                  maxwidth={this.IsWideScreen(data) ? '1450px' : '1400px'}
                  backButton={() => goBack(self, self.ScreenName)}
                />
              )}
              {this.state.newMatrixTableHelper && (
                <Modal transparent={true}>
                  <ModalWindow>{this.renderNewRowButton()}</ModalWindow>
                </Modal>
              )}

              {this.state.activeDelete && (
                <Modal transparent={true}>
                  <YesNoWindow
                    question={translate('RemoveQuestion')}
                    yes={() => this.deleteRecord()}
                    no={() => this.setState({activeDelete: false})}
                  />
                </Modal>
              )}
            </WindowWrap>
          );
        }}
      </LangColorContext.Consumer>
    );
  }
}
function TimeTables() {
  return (
    <Drawer.Navigator
      style={{background: 'white'}}
      screenOptions={{headerShown: false}}
      backBehavior={GetDefaultBackBehaviour()}
      drawerStyle={{display: 'none'}}
    >
      <Drawer.Screen
        name="TimeTablesList"
        component={TimeTablesList}
        options={{
          title: translate('TimeTables'),
        }}
      />
      <Drawer.Screen
        name="TimeTablesRecord"
        component={TimeTablesRecord}
        backBehavior={GetDefaultBackBehaviour()}
        options={{
          title: translate('TimeTable'),
        }}
        getId={({params}) => params.id}
      />
    </Drawer.Navigator>
  );
}

export default TimeTables;
